import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSy...", // Pastikan ini API Key kamu yang benar
  authDomain: "vix1on-chat.firebaseapp.com",
  
  // GUNAKAN URL LENGKAP INI (Tanpa :null di ujungnya)
  databaseURL: "https://vix1ion-chat-default-rtdb.asia-southeast1.firebasedatabase.app",
  
  projectId: "vix1on-chat",
  storageBucket: "vix1on-chat.appspot.com",
  messagingSenderId: "...",
  appId: "..."
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);